module.exports = __webpack_public_path__ + "img/source04_03.0b73c81a.png";